<template>
  <div>
    <TheNavigationPanel/>
     <router-view></router-view>
  </div>
</template>

<script>
import TheNavigationPanel from '../components/TheNavigationPanel';

export default {
  name: 'mainlayout',
  components: {
    TheNavigationPanel,
  },
  data: () => ({
  
  }),

  // created: function () {
  //   axios.interceptors.response.use(null, error => {
  //     if (error.response.status === 401) {
  //     this.$router.push('/')
  //     }

  //     return Promise.reject(error);
  //   });
  // }
   
};
</script>
<style  scoped>
 
</style>